import colors from 'config/colors.module.scss';
import { DonationOutput } from 'gql/types';
import { getTranslation } from 'utils/getTranslation';

const t = getTranslation('donor.TemperatureChart');

export const getConfig = (donationData: DonationOutput[]) => {
  return {
    data: donationData,
    xField: 'donationDate',
    yField: 'temperature',
    color: colors.pastelPurple,
    xAxis: {
      title: {
        text: t('date'),
      },
    },
    yAxis: {
      title: {
        text: t('temperature'),
      },
      alias: t('temperature'),
    },
  };
};
